var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12,
    r: 12,
    fill: "#838383"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 13.5C14.933 13.5 16.5 11.933 16.5 10C16.5 8.067 14.933 6.5 13 6.5C11.067 6.5 9.5 8.067 9.5 10C9.5 11.933 11.067 13.5 13 13.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4.5C11.8675 4.49957 10.7625 4.84887 9.83602 5.50018C8.90955 6.15149 8.20681 7.07301 7.82386 8.1388C7.44091 9.20459 7.39643 10.3626 7.69651 11.4547C7.99659 12.5467 8.62658 13.5194 9.50037 14.2398V19C9.50036 19.0852 9.52214 19.1691 9.56364 19.2435C9.60514 19.3179 9.66499 19.3806 9.7375 19.4254C9.81 19.4702 9.89276 19.4957 9.97791 19.4995C10.0631 19.5033 10.1478 19.4853 10.224 19.4472L12.9999 18.059L15.7768 19.4472C15.853 19.4853 15.9377 19.5033 16.0229 19.4995C16.108 19.4957 16.1908 19.4701 16.2632 19.4253C16.3357 19.3805 16.3956 19.3179 16.4371 19.2435C16.4786 19.169 16.5004 19.0852 16.5004 19V14.2392C17.374 13.5187 18.0038 12.5459 18.3037 11.454C18.6036 10.362 18.559 9.20403 18.176 8.13835C17.793 7.07267 17.0902 6.15126 16.1638 5.50004C15.2373 4.84882 14.1324 4.49956 13 4.5V4.5ZM13 14.5C12.11 14.5 11.24 14.2361 10.4999 13.7416C9.75991 13.2471 9.18314 12.5443 8.84254 11.7221C8.50195 10.8998 8.41283 9.99501 8.58647 9.12209C8.7601 8.24918 9.18868 7.44736 9.81802 6.81802C10.4474 6.18868 11.2492 5.7601 12.1221 5.58647C12.995 5.41283 13.8998 5.50195 14.7221 5.84254C15.5443 6.18314 16.2471 6.75991 16.7416 7.49993C17.2361 8.23996 17.5 9.10998 17.5 10C17.4987 11.1931 17.0241 12.3369 16.1805 13.1805C15.3369 14.0241 14.1931 14.4987 13 14.5V14.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestDisable);
export default __webpack_public_path__ + "static/media/test_disable.567dc40aa23bbf6bcc2635d7c6f6a17e.svg";
export { ForwardRef as ReactComponent };